import { createContext, useState, ReactNode } from 'react';

type SidebarContextType = {
  sidebar: ReactNode | null;
  setSidebar: (content: ReactNode | null) => void;
};

export const SidebarContext = createContext<SidebarContextType>({
  sidebar: null,
  setSidebar: () => {},
});

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [sidebar, setSidebar] = useState<ReactNode | null>(null);
  return (
    <SidebarContext.Provider value={{ sidebar, setSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
}

